// Enhances the LOCATION_CHANGE action to include rootPath and URL,
// needed for remembering page paths
export default store => next => (action) => {
  if (action.type !== "@@router/LOCATION_CHANGE") {
    return next(action);
  }

  const { location } = store.getState().router;

  let currentPath;
  let rootPath;
  let url;

  if (location) {
    currentPath = location && location.pathname;
    rootPath = currentPath && currentPath.split("/")[1];
    url = location.pathname + location.search;
  }

  return next(
    { ...action, rootPath, url }
  );
};
